import api from '../../../services/api';
import { normalizeWZDocument, normalizeWZDocuments, type WZDocumentDto } from '../../../dto/wz';

/**
 * WZ documents of one customer order for the ZK card steps „W dostawie” and
 * „Dostarczone” (decision 2026-10-04, F5/F6). Reads go through the WZ API, so
 * the backend redaction applies as everywhere else: the WZ cost
 * (`costOfGoodsSold`) is absent for roles without warehouse cost access and
 * sale prices are never on a WZ for Operations. Needs warehouse document
 * access (`requireWarehouseDocumentAccess`); the Handlowiec does not read WZ.
 */

export async function fetchOrderWzDocuments(orderId: string): Promise<WZDocumentDto[]> {
  const { data } = await api.get('/wz', { params: { orderId } });
  const listed = normalizeWZDocuments(data, 'orderWzDocuments')
    .filter((document) => document.orderId === orderId);
  // The list has no lines or attachments; each document is read once more.
  const detailed = await Promise.all(listed.map(async (document) => {
    const response = await api.get(`/wz/${encodeURIComponent(document.id)}`);
    return normalizeWZDocument(response.data, 'orderWzDocument');
  }));
  return detailed.sort((a, b) => (a.issueDate || a.createdAt).localeCompare(b.issueDate || b.createdAt));
}
